export function getLeadDetailsActionPolicy({ readOnly, isDnc = false }) {
  if (readOnly) {
    return {
      proposal: { visible: true, enabled: false },
      task: { visible: true, enabled: false },
      edit: { visible: true, enabled: false },
      remove: { visible: false, enabled: false },
      call: { visible: true, enabled: !isDnc },
      sms: { visible: true, enabled: !isDnc },
      email: { visible: true, enabled: !isDnc },
      createActivity: { visible: false, enabled: false },
      tags: { visible: true, enabled: true },
      rating: { visible: true, enabled: true },
    }
  }
  const on = { visible: true, enabled: true }
  const outreach = { visible: true, enabled: !isDnc }
  return {
    proposal: on,
    task: on,
    edit: on,
    remove: on,
    call: outreach,
    sms: outreach,
    email: outreach,
    createActivity: on,
    tags: on,
    rating: on,
  }
}
